import { render, staticRenderFns } from "./tj-query.vue?vue&type=template&id=513921eb&scoped=true&"
import script from "./tj-query.vue?vue&type=script&lang=js&"
export * from "./tj-query.vue?vue&type=script&lang=js&"
import style0 from "./tj-query.vue?vue&type=style&index=0&id=513921eb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513921eb",
  null
  
)

export default component.exports